import { render, staticRenderFns } from "./SchoolDistrictsListBody.vue?vue&type=template&id=b43816a2&scoped=true&"
import script from "./SchoolDistrictsListBody.vue?vue&type=script&lang=js&"
export * from "./SchoolDistrictsListBody.vue?vue&type=script&lang=js&"
import style0 from "./SchoolDistrictsListBody.vue?vue&type=style&index=0&id=b43816a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43816a2",
  null
  
)

export default component.exports